module.exports = __webpack_public_path__ + "img/center-2014-media-development.39761134.jpg";